import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
    // Setting Home Page
    {
        path: '/setting/',
        name: 'Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1.read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting')
    },

    // Setting User Setting
    {
        path: '/setting/user/',
        name: 'List User Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-u1'].read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/user')
    },

    // Setting Create Group User
    {
        path: '/setting/user/groupcreate',
        name: 'Create Setting Group User',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-u1'].create) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/user/GroupCreate')
    },

    // Detail User Group setting
    {
        path: '/setting/user/groupupdate/:id',
        name: 'Update Setting Group User',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-u1'].update) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/user/GroupCreate')
    },

    // Setting Employee Setting
    {
        path: '/setting/employee/',
        name: 'List Employee Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-e1'].read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/employee')
    },

    // Setting General Setting
    {
        path: '/setting/general/',
        name: 'List General Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-g1'].read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/general')
    },

    // Setting Company Profile
    {
        path: '/setting/company/',
        name: 'List Company Profile Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/company')
    },
    {
        path: '/setting/company/address',
        name: 'Company Profile Address',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/company/form')
    },
    {
        path: '/setting/company/address/:id',
        name: 'Company Profile Address Update',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/company/form')
    },
    // Setting Tracker Setting
    {
        path: '/setting/tracker',
        name: 'List Tracker Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-t1'].update) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/tracker')
    },

    // Setting Tracker Setting
    {
        path: '/setting/tracker/trackersetting/:id',
        name: 'Setting Tracker',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/tracker/TrackerSetting')
    },

    // Setting Fleet Group Setting
    {
        path: '/setting/fleetgroup',
        name: 'List Fleet Group Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-vg1'].read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/fleetgroup')
    },

    // Detail Fleet Group setting
    {
        path: '/setting/fleetgroup/update/:id',
        name: 'Fleet Group Detail',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-vg1'].update) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/fleetgroup/form')
    },

    // Setting Form Fleet Group Setting
    {
        path: '/setting/fleetgroup/create',
        name: 'Form Fleet Group',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-vg1'].create) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/fleetgroup/form')
    },

    // Setting Fleet
    {
        path: '/setting/fleet/',
        name: 'List Fleet Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-v1'].read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/fleet')
    },

    // Setting Maintenance
    {
        path: '/setting/maintenance',
        name: 'List Maintenance Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-m1'].update) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                } next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/maintenance')
    },

    // Setting Odometer
    {
        path: '/setting/odometer',
        name: 'List Odometer Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.s1['s1-o1'].read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/odometer')
    },

    {
        path: '/setting/maintenance/parts',
        name: 'Setting Service Parts',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/maintenance/parts')
    },

    {
        path: '/setting/live-view',
        name: 'Setting Live View',
        meta: {
            authRequired: true,
            hasAccess: Helper.methods.getAccessRight(),
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/liveview')
    },

    {
        path: '/setting/maintenance/service',
        name: 'Setting Service Activity',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/maintenance/service')
    },

    {
        path: '/setting/development',
        name: 'Setting Development',
        meta: {
            authRequired: true,
            hasAccess: Helper.methods.getAccessRight(),
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "setting" */ '@/router/views/setting/development')
    },
]